import "./POIConference.scss";
import POIStep from "@/components/POI/POIStep/POIStep.vue";
import POIConferenceFields from "@/components/POI/PoiConferenceFields/POIConferenceFields.vue";
export default {
  name: "POIConference",
  components: {
    POIConferenceFields,
    POIStep
  },
  props: ["step", "position", "editedItem", "isOwnedBySubPrincipal"],
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    saveHelper() {
      this.$emit("save", false);
    }
  }
};
